export const ID = 'fa1d8ad4-c2ce-4979-9f0b-e35590396bc0';

export const NAME = 'Text Accordion';
